import { gettext } from '@eventbrite/i18n';

export const SET_UP_ACCOUNT_TOOLTIP = gettext(
    'Set up a bank account to receive your event funds',
);
